import { CmtsRcaPanel } from "../components/rca/CmtsRcaPanel.js";
export type CmtsRcaPageProps = Readonly<{ selectedRecordId?: string | undefined; diagnostics?: unknown | undefined }>;
export function CmtsRcaPage(props: CmtsRcaPageProps) { return <CmtsRcaPanel {...(props.selectedRecordId ? { selectedRecordId: props.selectedRecordId } : {})} />; }
